window.$ = window.jQuery = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');
var fitvids = require('fitvids');
var objectFitImages = require('object-fit-images');

Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

$(document).ready(function () {
    initNav();
    initCarousel();
    fitvids();
    objectFitImages();
});

$(window).on('load', function () {
    smoothScroll();
})

var initNav = function () {
    $('.mobile-nav-toggle').on('touchstart click', function (e) {
        e.preventDefault();
        $('body').toggleClass('mobile-nav-open');
    });

    $('.search-toggle').on('touchstart click', function (e) {
        e.preventDefault();
        $('body').removeClass('mobile-nav-open');
        $('body').toggleClass('search-open');

        $('.search-form input[type="text"]').focus();
    });

    $('.search-form .close-btn').on('touchstart click', function (e) {
        e.preventDefault();
        $('body').removeClass('search-open');
    })

    $('.icon-search a').on('touchstart click', function (e) {
        e.preventDefault();
        $('.site-header__search-form').toggleClass('active');
        $('.site-header__search-form input[type="search"]').trigger('focus');
    });

    $(window).on('scroll', function (e) {
        if ($('body').hasClass('home')) {
            if ($(window).scrollTop() > 0) {
                $('body').addClass('scrolled');
            } else {
                $('body').removeClass('scrolled');
            }
        }
    }).trigger('scroll');
}

var initCarousel = function () {
    // resources carousel
    // var $carousel = $('.resources-carousel .carousel').flickity({
    //     wrapAround: true,
    //     initialIndex: 0,
    //     cellAlign: 'left',
    //     pageDots: true
    // });

    var $imageCarousel = $('.layout--image-carousel').flickity({
        wrapAround: true,
    })
}

var smoothScroll = function () {
    let hash = window.location.hash;
    if (hash) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top - 150,
        }, 1000)
    }
}